module.exports = __webpack_public_path__ + "static/media/hat-cowboy.25240ea4.svg";